/*
 * @Description: 走势图
 * @Date: 2024-01-11 14:07:18
 */
const views = (require as any).context(
  './',
  true,
  /pc-module-proportion-\d+\.vue/
);

export default views.keys().map(path => {
  return views(path).default;
});
